import reduxConnector from 'root/src/shared/util/reduxConnector'

import fieldValue from 'root/src/client/logic/form/selectors/fieldValue'
import fieldMax from 'root/src/client/logic/form/selectors/fieldMax'
import fieldHint from 'root/src/client/logic/form/selectors/fieldHint'
import fieldLabel from 'root/src/client/logic/form/selectors/fieldLabel'
import fieldError from 'root/src/client/logic/form/selectors/fieldError'
import fieldInfo from 'root/src/client/logic/form/selectors/fieldInfo'
import fieldHasError from 'root/src/client/logic/form/selectors/fieldHasError'
import fieldPlaceholder from 'root/src/client/logic/form/selectors/fieldPlaceholder'
import fieldDefaultStaticText from 'root/src/client/logic/form/selectors/fieldDefaultStaticText'
import fieldMultiline from 'root/src/client/logic/form/selectors/fieldMultiline'
import fieldMultilineRows from 'root/src/client/logic/form/selectors/fieldMultilineRows'
import fieldOptionsSelector from 'root/src/client/logic/form/selectors/fieldOptionsSelector'
import dropdownAsyncOptionsSelector from 'root/src/client/logic/form/selectors/dropdownAsyncOptionsSelector'
import fieldFullWidthSelector from 'root/src/client/logic/form/selectors/fieldFullWidthSelector'
import fieldActionButtonSelector from 'root/src/client/logic/form/selectors/fieldActionButtonSelector'
import fieldAuthenticationSelector from 'root/src/client/logic/form/selectors/fieldAuthenticationSelector'
import fieldUnauthTextSelector from 'root/src/client/logic/form/selectors/fieldUnauthTextSelector'
import authenticationSelector from 'root/src/client/logic/auth/selectors/authenticationSelector'
import prePopulateDataSelector from 'root/src/client/logic/form/selectors/prePopulateDataSelector'
import attachmentFormats from 'root/src/client/logic/form/selectors/attachmentFormats'
import attachmentText from 'root/src/client/logic/form/selectors/attachmentText'
import fieldHalfHeight from 'root/src/client/logic/form/selectors/fieldHalfHeight'
import downdropOptionsFilterSelector from 'root/src/client/logic/form/selectors/downdropOptionsFilterSelector'
import fieldAppendConditionSelector from 'root/src/client/logic/form/selectors/fieldAppendConditionSelector'
import fieldsResetConditionSelector from 'root/src/client/logic/form/selectors/fieldsResetConditionSelector'
import hideDowndropArrowSelector from 'root/src/client/logic/form/selectors/hideDowndropArrowSelector'
import fieldMaxRowsSelector from 'root/src/client/logic/form/selectors/fieldMaxRowsSelector'
import fieldMinRowsSelector from 'root/src/client/logic/form/selectors/fieldMinRowsSelector'
import debounceInputSelector from 'root/src/client/logic/form/selectors/debounceInputSelector'

import variantOptions from 'root/src/client/logic/form/selectors/variantOptions'
import optionsPromiseType from 'root/src/client/logic/form/selectors/optionsPromiseType'
import setInput from 'root/src/client/logic/form/thunks/setInput'
import pushStepId from 'root/src/client/logic/form/thunks/pushStepId'
import multiWayInputOnSelect from 'root/src/client/logic/form/thunks/multiWayInputOnSelect'
import multiWayInputOnSelectFailure from 'root/src/client/logic/form/thunks/multiWayInputOnSelectFailure'
import dispatcher from 'root/src/client/logic/app/thunks/dispatcher'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import fieldActionButton from 'root/src/client/logic/form/thunks/fieldActionButton'
import assetsAdditionalField from 'root/src/client/logic/form/selectors/assetsAdditionalField'
import arrayFieldMaxItems from 'root/src/client/logic/form/selectors/arrayFieldMaxItems'
import fieldLoadingSelector from 'root/src/client/logic/form/selectors/fieldLoadingSelector'
import fieldBudgetTypesSelector from 'root/src/client/logic/form/selectors/fieldBudgetTypesSelector'
import fieldMaxValueSelector from 'root/src/client/logic/form/selectors/fieldMaxValueSelector'
import fieldMinValueSelector from 'root/src/client/logic/form/selectors/fieldMinValueSelector'
import defaultValueSelector from 'root/src/client/logic/form/selectors/defaultValueSelector'
import modifyOptionsSelector from 'root/src/client/logic/form/selectors/modifyOptionsSelector'

export default reduxConnector(
	[
		['fieldValue', fieldValue],
		['fieldMax', fieldMax],
		['fieldHint', fieldHint],
		['fieldLabel', fieldLabel],
		['fieldError', fieldError],
		['fieldHasError', fieldHasError],
		['fieldPlaceholder', fieldPlaceholder],
		['fieldDefaultStaticText', fieldDefaultStaticText],
		['fieldMultiline', fieldMultiline],
		['fieldMultilineRows', fieldMultilineRows],
		['dropdownAsyncOptions', dropdownAsyncOptionsSelector],
		['fieldOptions', fieldOptionsSelector],
		['fieldInfo', fieldInfo],
		['fieldFullWidth', fieldFullWidthSelector],
		['fieldActionButton', fieldActionButtonSelector],
		['fieldAuthentication', fieldAuthenticationSelector],
		['fieldUnauthText', fieldUnauthTextSelector],
		['authentication', authenticationSelector],
		['variantOptions', variantOptions],
		['optionsPromiseType', optionsPromiseType],
		['prePopulateData', prePopulateDataSelector],
		['attachmentFormats', attachmentFormats],
		['attachmentText', attachmentText],
		['fieldHalfHeight', fieldHalfHeight],
		['assetsAdditionalField', assetsAdditionalField],
		['arrayFieldMaxItems', arrayFieldMaxItems],
		['fieldLoading', fieldLoadingSelector],
		['budgetTypes', fieldBudgetTypesSelector],
		['fieldMaxValue', fieldMaxValueSelector],
		['fieldMinValue', fieldMinValueSelector],
		['downdropOptionsFilter', downdropOptionsFilterSelector],
		['fieldAppendCondition', fieldAppendConditionSelector],
		['fieldsResetCondition', fieldsResetConditionSelector],
		['hideDowndropArrow', hideDowndropArrowSelector],
		['fieldMinRows', fieldMinRowsSelector],
		['fieldMaxRows', fieldMaxRowsSelector],
		['defaultValue', defaultValueSelector],
		['debounceInput', debounceInputSelector],
		['modifyOptions', modifyOptionsSelector],
	],
	[
		['pushStepId', pushStepId],
		['displayModal', displayModal],
		['setInput', setInput],
		['multiWayInputOnSelect', multiWayInputOnSelect],
		['multiWayInputOnSelectFailure', multiWayInputOnSelectFailure],
		['dispatcher', dispatcher],
		['fieldActionButtonFn', fieldActionButton],
	],
)
